// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-7bfcddd8]{color:var(--colour-wcag-blue);display:block;margin:-.5em 0 .5em}.location-options[data-v-7bfcddd8]{align-items:center;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;margin:.5em 0 1em}.location-options.point-search[data-v-7bfcddd8] .error{padding:.5em 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
